export enum ScopingResource {
  Control = 'control',
  Framework = 'framework',
}

export type ScopingType = ScopingResource | null;

export enum ScopingAction {
  Add = 'add',
  Remove = 'remove',
}

export interface OverrideContext {
  resource_type?: ScopingType;
  resource_id?: string;
}

export interface ScopingPayload {
  action?: ScopingAction;
  evidences_ids?: string[];
  policies_ids?: string[];
  override_context?: OverrideContext;
}

export interface RequirementScopingOverrides {
  [resource_id: string]: {
    evidences?: {
      [evidence_id: string]: boolean;
    };
    policies?: {
      [evidence_id: string]: boolean;
    };
    resource_type?: ScopingResource;
  };
}
